import { useEffect } from 'react';

import type { Table } from './useTable/types.js';

/**
 * Remeasures all columns when row density changes, data is loaded, or the column definition changes.
 * @internal
 */
export function useColumnRemeasure<TData>(table: Table<TData>): void {
  const rowDensity = table.getVisualVariantOptions().rowDensity;
  const rowCount = table.getRowModel().rows.length;

  useEffect(() => {
    if (rowCount > 0) {
      table.remeasureAllColumns();
    }
  }, [table, rowDensity, rowCount, table.options.columns]);
}
